module.exports = __webpack_public_path__ + "static/img/tec-lang.9003753.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/technology/tec-lang.jpg
// module id = 7s4O
// module chunks = 1